import { useLazyQuery } from '@apollo/client'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { FileStatus, ImageProps } from '../../components/UploadBox/ImageBox'
import { UploadBox } from '../../components/UploadBox/index'
import { ROOMTYPE_IMAGES_QUERY } from '../../graphql/upload'
import { getRoleFromStorage } from '../../helpers/userData'
import roomTypePagesRoleManagement from '../../staticRoleManagement/roomTypeRoleManagement'
import { Image } from '../../types/image'

export const UploadBoxForRoomType = () => {
  const [images, setImages] = useState<ImageProps[]>([])
  const params = useParams<{
    accommodationID: string
    propertyCode: string
    roomTypeCode: string
    roomTypeId: string
  }>()

  const [getImages, { data, loading }] = useLazyQuery<{
    roomTypeImages: Image[]
  }>(ROOMTYPE_IMAGES_QUERY, {
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    getImages({
      variables: {
        propertyCode: params.propertyCode,
        roomTypeCode: params.roomTypeCode
      }
    })
  }, [])
  useEffect(() => {
    if (data) {
      let newImages: ImageProps[] = []

      newImages = data.roomTypeImages.map((singleImage: Image) => ({
        fileURL: singleImage.url,
        status: FileStatus.COMPLETED,
        fileName: singleImage.name,
        fileSize: singleImage.size,
        mediaID: singleImage.id
      }))

      setImages(newImages)
    }
  }, [loading, data])

  const hasAccessToWriteRoomTypeImages = roomTypePagesRoleManagement
    .find(
      (item) =>
        item.route ===
        '/accommodations/:accommodationID/:propertyCode/room-types/:roomTypeId/:roomTypeCode/:page'
    )
    ?.tabs?.find((tabItem) => tabItem.params.page === 'images')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <>
      <UploadBox
        hasAccess={hasAccessToWriteRoomTypeImages}
        loading={loading}
        entityCode={params.propertyCode} //use it in asset service, do not change this!
        entityid={params.roomTypeId}
        entityType={'RoomType'}
        images={images}
        setImages={setImages}
        imageType={'Image'}
        roomTypeCode={params.roomTypeCode}
      />
    </>
  )
}
